import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e0f379c")

_pushScopeId("data-v-2e0f379c")
const _hoisted_1 = { class: "element-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EditableTable = _resolveComponent("EditableTable")
  const _directive_contextmenu = _resolveDirective("contextmenu")

  return (_openBlock(), _createBlock("div", {
    class: ["editable-element-table", { 'lock': _ctx.elementInfo.lock }],
    ref: "elementRef",
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
    }
  }, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_EditableTable, {
        onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        data: _ctx.elementInfo.data,
        width: _ctx.elementInfo.width,
        colWidths: _ctx.elementInfo.colWidths,
        outline: _ctx.elementInfo.outline,
        theme: _ctx.elementInfo.theme,
        editable: _ctx.editable,
        onChange: _cache[2] || (_cache[2] = data => _ctx.updateTableCells(data)),
        onChangeColWidths: _cache[3] || (_cache[3] = widths => _ctx.updateColWidths(widths)),
        onChangeSelectedCells: _cache[4] || (_cache[4] = cells => _ctx.updateSelectedCells(cells))
      }, null, 8, ["data", "width", "colWidths", "outline", "theme", "editable"]),
      (!_ctx.editable || _ctx.elementInfo.lock)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["table-mask", { 'lock': _ctx.elementInfo.lock }],
            onDblclick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.startEdit())),
            onMousedown: _cache[6] || (_cache[6] = $event => _ctx.handleSelectElement($event))
          }, [
            _createVNode("div", {
              class: "mask-tip",
              style: { transform: `scale(${ 1 / _ctx.canvasScale })` }
            }, "双击编辑", 4)
          ], 34))
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_contextmenu, _ctx.contextmenus]
    ])
  ], 6))
})